import { render, staticRenderFns } from "./Costruttori.vue?vue&type=template&id=92637d18&"
import script from "./Costruttori.vue?vue&type=script&lang=js&"
export * from "./Costruttori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports